export default __webpack_public_path__ + "static/media/EPS-Sandwich-Panel.31039c2f.jpg";